export default "__VITE_ASSET__BdBTCL7u__"